<template>
  <div class="main">
    <div class="product">
      <!-- 面包屑 -->
      <div class="pro">
        <router-link :to="{ path: '/' }" class="link"
          ><span>{{ $t("nav.home") }} > </span></router-link
        >{{ $t("nav.contact") }}
      </div>
      <!-- 联系我们 -->
      <div class="h_title">
        <el-image src="./static/image/tleft.png" fit="contain"></el-image
        >{{ $t("nav.contact") }}
        <el-image src="./static/image/tright.png" fit="contain"></el-image>
      </div>
      <!-- 业务咨询 -->
      <div class="jli">{{ $t("cont.ywzx") }}</div>
      <div class="list">
        <div class="one">
          <div class="title">{{ $t("cont.gszj") }}：{{ lx.pub_phone }}</div>
          <div class="ti_hie">{{ $t("cont.gnywe") }}：{{ lx.yw_email }}</div>
          <div class="ti_hui">{{ $t("cont.fzgw") }}</div>
        </div>
        <div class="one">
          <!-- 传真 -->
          <div class="title" style="display:none;">{{ $t("cont.cz") }}：{{ lx.fax }}</div>
          <!-- 证券事务邮箱： -->
          <div class="ti_hie" style="display:none;">{{ $t("cont.zjyx") }}：{{ lx.zq_email }}</div>
          <!-- ti_hie -->
          <div class=" title">{{ $t("cont.lxdh") }}：{{ lx.lx_phone }}</div>
          <div class="ti_hui">{{ $t("cont.fzgw") }}</div>
        </div>

        <div class="one">
          <div class=" title">{{$t('dz')}}</div>
          <div class="ti_hui" v-if="$i18n.locale == 'zh'">{{phone.address}}</div>
          <div class="ti_hui" v-else-if="$i18n.locale == 'en'">{{phone.y_address}}</div>
          <div class="ti_hui" v-else>{{phone.e_address}}</div>
        </div>
        <!-- <div class="one" style="margin-top: 60px;"> -->
          <!-- HR邮箱 -->
          <!-- <div class="ti_hie">HR{{ $t("cont.yx") }}：{{ lx.hr_email }}</div> -->
          <!-- <div class="ti_hui"> -->
            <!-- 负责接收国内客户，技术咨询相关邮件 -->
            <!-- {{ $t("cont.fzgw") }} -->
          <!-- </div> -->
        <!-- </div> -->
      </div>
      <!-- 我们能帮您什么呢？ -->
      <div class="jli">{{ $t("cont.help") }}？</div>
      <div class="about" v-if="$i18n.locale == 'zh'" v-html="lx.help">
      </div>
      <div class="about" v-else-if="$i18n.locale == 'en'"  v-html="lx.y_help">
      </div>
      <div class="about" v-else  v-html="lx.e_help">
      </div>

      <!--  -->
      <div class="lanse">{{ $t("cont.jdlxfs") }}！</div>
      <div class="cem">
        <el-form ref="form" label-width="120px">
          <div class="formCenter ter">
            <el-form-item :label="$t('cont.mz')" style="width: 50%">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('cont.xing')" style="width: 50%">
              <el-input v-model="form.surname"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('cont.zc')">
              <el-input v-model="form.job"></el-input>
            </el-form-item> -->
          </div>
          <div class="formCenter ter">
            
            <el-form-item :label="$t('cont.yx')" style="width: 50%">
              <el-input v-model="form.mail"></el-input>
            </el-form-item>
            <el-form-item :label="$t('cont.dh')"  style="width: 50%">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </div>
          <div class="formCenter ter">
            <el-form-item :label="$t('cont.gj')" style="width: 50%">
              <el-input v-model="form.country"></el-input>
            </el-form-item>
           <el-form-item :label="$t('cont.gs')"  style="width: 50%">
              <el-input v-model="form.company"></el-input>
            </el-form-item>
          </div>
          <el-form-item
            :label="$t('cont.zs')"
            prop="desc"
            class="miaoshu"
            style="width: 97%"
          >
            <el-input
              type="textarea"
              placeholder=""
              v-model="form.desc"
            ></el-input>
          </el-form-item>

          <!-- 表格下载 -->
          <div class="lanse">{{$t('cont.bgxz')}}</div>
         
          <div class="zht">
            <a :href="lx.xjd" v-if="$i18n.locale == 'zh'" > 
              <div class="zleft"> <div> {{$t('cont.xjd')}}</div> <i class="el-icon-download"></i>
              </div>
            </a>
            <a :href="lx.y_xjd" v-else-if="$i18n.locale == 'en'">
              <div class="zleft"> <div> {{$t('cont.xjd')}}</div> <i class="el-icon-download"></i>
              </div>
            </a>
            <a :href="lx.e_xjd" v-else>
              <div class="zleft"> <div> {{$t('cont.xjd')}}</div> <i class="el-icon-download"></i>
              </div>
            </a>


            <a :href="lx.bzh" v-if="lx.bzh&&$i18n.locale == 'zh'">
              <div class="zleft">
                <div>  {{$t('cont.bzh')}} </div><i class="el-icon-download"></i>
              </div>
            </a>
            <a :href="lx.y_bzh" v-if="lx.bzh&&$i18n.locale == 'en'">
              <div class="zleft">
                <div>  {{$t('cont.bzh')}} </div><i class="el-icon-download"></i>
              </div>
            </a>
            <a :href="lx.e_bzh" v-else>
              <div class="zleft">
                <div>  {{$t('cont.bzh')}} </div><i class="el-icon-download"></i>
              </div>
            </a>
          </div>
          <!-- 文件上传 -->
          <div class="lanse">{{$t('cont.wjsc')}}</div>
          <el-form-item :label="$t('cont.ywzx')" style="width: 50%">
            <el-upload
              class="upload-demo"
              action="/api/upload/upload"
              name="file"
              :on-success="handlePreview"
              multiple
              :limit="1"
            >
              <el-button size="small" type="primary">{{$t('cont.djsc')}}</el-button>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="tijiao" @click="onSubmit()">{{ $t("cont.sbum") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { MessageBox, Message } from "element-ui";
Vue.prototype.$message = Message;

export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        service: "",
        country: "",
        mail: "",
        company: "",
        job: "",
        desc: "",
        surname: "",
      },
      lx: {},
      file:'',
      fileLists: [],

				phone:{},

    };
  },
  mounted() {
    this.getlx()
			this.getPhone()

  },
  methods: {
    getPhone() {
				var that = this;
				this.$axios
					.post("/api/index/down_phone", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.phone = ret.data.data;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
    handlePreview(response, file, fileList) {
      if(response.code ==0){
          this.file = response.data.data;
  
      }else{
        this.$message({
            message: response.msg,
            type: "error",
          });
      }
    },
    onSubmit() {
				var that = this;
				this.$axios
					.post("/api/index/apply", {
					   name: this.form.name,
              phone: this.form.phone,
              service: this.form.service,
              country: this.form.country,
              mail: this.form.mail,
              company: this.form.company,
              job: this.form.job,
              desc: this.form.desc,
              surname: this.form.surname,
              lang: this.$i18n.locale,
              file:this.file
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
						 that.$message({
            message: "提交成功",
            type: "success",
          });
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
    // onSubmit() {
    //   var param = {
    //     name: this.form.name,
    //     phone: this.form.phone,
    //     service: this.form.service,
    //     country: this.form.country,
    //     mail: this.form.mail,
    //     company: this.form.company,
    //     job: this.form.job,
    //     desc: this.form.desc,
    //     surname: this.form.surname,
    //     lang: this.$i18n.locale,
    //     file:this.file
    //   };
    //   var that = this;
    //   this.$axios({
    //     url: "/api/index/apply",
    //     data: param,
    //     method: "post",
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   }).then(function (ret) {
    //     if (ret.data.code == 0) {
    //       that.$message({
    //         message: "提交成功",
    //         type: "success",
    //       });
    //     } else {
    //       that.$fail(ret.data.msg);
    //     }
    //   });
    // },
    // 获取文件内容/api/upload/upload
    getContent(response) {
      if (response.code == 0) {
        document.getElementById("content").innerHTML = response.data.newstr;
        this.account_con = response.data.newstr;
      }
    },
    getlx() {
      var that = this;
      this.$axios.post("/api/index/lx", {}).then(function (ret) {
        if (ret.data.code == 0) {
          that.lx = ret.data.data;
        } else {
          that.$fail(ret.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .introduce {
    width: 1200px;
    height: 433px;
    margin: 60px 0;
    display: flex;
    // align-items: center;
    justify-content: space-between;

    .ad {
      width: 800px;
      height: 433px;
    }

    .info {
      width: 800px;
      height: 433px;
      padding-left: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 30px;
        color: #004098;
        font-weight: bold;
      }

      span {
        display: block;
        width: 40px;
        height: 4px;
        background: #004098;
        margin-top: 20px;
      }

      .cro {
        font-size: 18px;
        color: #333;
        margin: 20px 0;
      }

      .text {
        height: 300px;

        p {
          font-size: 16px;
          color: #999;
          text-indent: 2em;
        }
      }
      .link {
        font-size: 16px;
        color: #004098;
        display: flex;
        align-items: center;
        display: inline;
        cursor: pointer;

        .el-image {
          width: 16px;
          height: 16px;
          margin-left: 5px;
        }
      }
    }
    .info2 {
      background-color: #f7f8fa;
      padding: 50px 40px;
    }
  }
  .h_title {
    font-size: 30px;
    color: #004098;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    padding: 40px 0;
    font-weight: bold;

    .el-image {
      // width: 515px;
      width: 450px;
      height: 13px;
    }
  }

  .range {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .li {
      font-size: 16px;
      color: #333;
      display: flex;
      align-items: center;
      flex-direction: column;

      .el-image {
        width: 70px;
        height: 70px;
        padding: 15px;
        margin-bottom: 15px;
        background-color: #004098;
      }
    }
  }

  .el-carousel {
    width: 1200px;
  }

  .about {
    width: 1200px;
    margin: 10px auto;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
  }
  .jli {
    width: 1200px;
    margin: 50px auto;
    overflow: hidden;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  .imgs .el-image {
    width: 20px;
    height: 20px;
    margin-top: 15px;
    margin-right: 20px;
    vertical-align: -5px;
  }
  .list_one {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 20px;
    color: #004098;
  }
  .list {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
  }
  .one {
    width: 33.3%;
    overflow: hidden;
    margin: 0 auto;
  }
  .title {
    width: 100%;
    overflow: hidden;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 20px;
    color: #004098;
    margin: 20px 0;
  }
  .ti_hie {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 40px;
    color: #333333;
  }
  .ti_hui {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 30px;
  }
  .lanse {
    width: 1200px;
    overflow: hidden;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #004098;
    margin: 20px;
  }
  .pro {
    width: 1200px;
    line-height: 30px;
    margin: 40px 0 0;
    overflow: hidden;
    text-align: left;
    font-size: 14px;
    a{
      text-decoration: none;
      color: #303133;
      font-weight: 700;
    }
  }
  .cem {
    width: 100%;
    overflow: hidden;
  }
  .formCenter {
    width: 1200px;
    display: flex;
  }
  .el-form-item {
    width: 33.33%;
  }
  .ter .el-form-item__label {
    width: 150px !important;
  }
  .ter .el-input__inner {
    width: 80% !important;
  }
  .shang {
    display: flex;
  }
  .shang .labe {
    margin-right: 10px;
    line-height: 40px;
  }
  .tijiao {
    width: 200px;
    margin: 20px auto;
    overflow: hidden;
    background: #004098;
    line-height: 50px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 50px;
    color: #ffffff;
    text-align: center;
  }
  .el-input__inner {
    background: #f7f7f7;
  }
}
.zht{
  width:600px;
  margin-left:20px;
  display:flex;
  justify-content:space-between;
}
.zht .zleft{
  width: 100%;
  background: #409EFF;
  display:flex;
  justify-content:space-between;
  color: #fff;
  padding: 2%;
   background: #409EFF;
}
.zleft div{
  width: 80%;
}
.zht a{
  display: block;
  width: 48%;
 
   padding: 2%;
}

.txt{
  width:1200px;
  margin:20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/contact.vue